import React from "react";
import { FileText, FileSpreadsheet, FileType2, FileOutput } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const FORMATS = [
  {
    key: "pdf",
    icon: FileType2,
    title: "Rapport PDF",
    desc: "Haute qualité, infographies vectorielles, mise en page institutionnelle.",
  },
  {
    key: "docx",
    icon: FileText,
    title: "Rapport Word",
    desc: "Modifiable, sections structurées, tableaux natifs Word.",
  },
  {
    key: "xlsx",
    icon: FileSpreadsheet,
    title: "Rapport Excel",
    desc: "Données brutes, formules, multi-onglets pour analyse avancée.",
  },
];

export default function Reports() {
  return (
    <div className="space-y-8" data-testid="reports-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-muted-foreground">
          Rapports
        </div>
        <h1 className="mt-1 text-3xl font-extrabold tracking-tight">
          Rapports téléchargeables
        </h1>
        <p className="mt-2 max-w-2xl text-sm text-muted-foreground">
          Exportez vos analyses vitalistes dans trois formats professionnels.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {FORMATS.map(({ key, icon: Icon, title, desc }) => (
          <Card key={key} data-testid={`format-card-${key}`} className="border-border">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Icon className="h-5 w-5 text-brand-gold" />
                {title}
              </CardTitle>
            </CardHeader>
            <CardContent className="text-sm text-muted-foreground">
              {desc}
            </CardContent>
          </Card>
        ))}
      </div>

      <Card data-testid="reports-empty" className="border-dashed">
        <CardContent className="flex flex-col items-center justify-center py-14 text-center">
          <div className="mb-4 rounded-full bg-muted p-4">
            <FileOutput className="h-6 w-6 text-muted-foreground" />
          </div>
          <h3 className="text-lg font-semibold">Aucun rapport pour le moment</h3>
          <p className="mt-1 max-w-md text-sm text-muted-foreground">
            Une fois une analyse complète, vous pourrez générer et télécharger
            vos rapports institutionnels ici.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
